import React from 'react';
import classNames from 'classnames';
import { IconAnonymousL, IconAnonymousXL, IconImageEnlargeL, IconImageEnlargeM } from '../../icons';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import SdkVideo from '../SdkVideo/SdkVideo';
import css from './Thumbnail.css';

export const Thumbnail = ({
    asset,
    sizes = '75vw',
    variants = ['landscape-crop2x'],
    onPreviewClick,
    previewRootClassName,
    hiddenAsset = false,
    videoProps = {},
    imageProps = {},
    isMobile,
}) => {
    const showPreviewBlock = typeof onPreviewClick === 'function';
    const hideImage = !asset?.isDefaultAvatar && hiddenAsset;

    const previewBlock = showPreviewBlock ? (
        <button
            onClick={onPreviewClick}
            className={classNames(css.showCarousel, {
                [previewRootClassName]: !!previewRootClassName,
                [css.anonym]: hideImage,
                [css.mob]: isMobile,
            })}
        >
            {isMobile ? <IconImageEnlargeM /> : <IconImageEnlargeL />}
        </button>
    ) : null;

    return (
        <>
            {previewBlock}
            {hideImage &&
                (isMobile ? (
                    <IconAnonymousL rootClassName={classNames(css.hiddenAsset, css.mob)} />
                ) : (
                    <IconAnonymousXL rootClassName={css.hiddenAsset} />
                ))}
            {asset && asset.type === 'video' ? (
                <SdkVideo
                    entity={asset}
                    {...videoProps}
                    rootClassName={classNames({
                        [videoProps.rootClassName]: !!videoProps.rootClassName,
                        [css.blurred]: hideImage,
                    })}
                />
            ) : (
                <ResponsiveImage
                    image={asset}
                    sizes={sizes}
                    variants={variants}
                    {...imageProps}
                    rootClassName={classNames({
                        [imageProps.rootClassName]: !!imageProps.rootClassName,
                        [css.blurred]: hideImage,
                    })}
                />
            )}
        </>
    );
};
